import { z } from 'zod';

export const RefundResponseSchema = z.object({
  amount: z.number(),
  status: z.string().optional(),
  note: z.string().optional(),
});

export const RefundListSchema = RefundResponseSchema.array();

export const RefundFormSchema = z.object({
  amount: z.number().min(0.01, 'Please enter an amount to refund'),
  note: z.string(),
});

export type RefundResponse = z.infer<typeof RefundResponseSchema>;
export type RefundForm = z.infer<typeof RefundFormSchema>;
export interface RefundRequest extends RefundForm {
  transactionId: string;
}
export type RefundList = z.infer<typeof RefundListSchema>;
